// TopNavbar.jsx
import { useContext } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  Flex,
  HStack,
  Button,
  Menu,
  Spacer,
  Portal,
} from "@chakra-ui/react";

import { useColorMode } from "../ui/color-mode"; // v3 snippet provides this hook

import { LuChevronDown } from "react-icons/lu"; // v3: replace @chakra-ui/icons
import AuthContext from "../../context/AuthContext";

export default function TopNavbar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { colorMode } = useColorMode();

  if (!user) return null;

  const isAdmin =
  user?.role === "ROLE_ADMIN" &&
  (user?.email === "haider@envaris.de" || user?.email === "walter@envaris.de");

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const linkColor = colorMode === "light" ? "blue.500" : "blue.300";
  const linkHover = colorMode === "light" ? "blue.800" : "blue.200";
  const bg = colorMode === "light" ? "white" : "gray.800";
  const borderColor = colorMode === "light" ? "gray.200" : "whiteAlpha.300";

  const links = [
    { label: "Liste Photovoltaikanlagen", to: "/anlagen" },
    { label: "Photovoltaikanlage anlegen", to: "/anlagen/neu" },
  ];

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      px={8}
      py={4}
      bg={bg}
      borderBottomWidth="1px"
      borderColor={borderColor}
      position="relative"
      zIndex={50}
    >
      {/* Left Navigation */}
      <HStack gap={8} fontWeight="medium">
        {/* Photovoltaikanlagen Dropdown */}

      </HStack>

      <Spacer />



      {/* Right */}
      <HStack gap={6}>


  {/* ADMIN dropdown – PUT HERE */}
  {isAdmin && (
    <Menu.Root autoSelect={false} navigate={(to) => navigate(to)}>
      <Menu.Trigger asChild>
        <Button
          variant="ghost"
          color={linkColor}
          _hover={{ color: linkHover, bg: "transparent" }}
        >
          Admin <LuChevronDown style={{ marginLeft: 8 }} />
        </Button>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            <Menu.Item asChild value="/admin/benutzerverwaltung">
              <RouterLink to="/admin/benutzerverwaltung">
                Benutzerverwaltung
              </RouterLink>
            </Menu.Item>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  )}



        <Button
          bg="blue.500"
          color="white"
          border="1px solid"
          borderColor="blue.700"
          _hover={{ bg: "blue.600" }}
          onClick={() => navigate("/dashboard")}
        >
          Dashboard
        </Button>


        <Menu.Root autoSelect={false} navigate={(to) => navigate(to)}>
          <Menu.Trigger asChild>
            <Button
              variant="ghost"
              color={linkColor}
              _hover={{ color: linkHover, bg: "transparent" }}
            >
              Systemdaten
              <LuChevronDown style={{ marginLeft: 8 }} />
            </Button>
          </Menu.Trigger>
          <Portal>
            <Menu.Positioner>
              <Menu.Content>
                <Menu.Item asChild value="/systemdaten/neuer-kunde">
                  <RouterLink to="/systemdaten/neuer-kunde">Neuen Kunden anlegen</RouterLink>
                </Menu.Item>
                <Menu.Item asChild value="/systemdaten/Kundenliste">
                  <RouterLink to="/systemdaten/Kundenliste">Kundenliste</RouterLink>
                </Menu.Item>
                <Menu.Item asChild value="/systemdaten/neuer-hersteller">
                  <RouterLink to="/systemdaten/neuer-hersteller">Neuen Hersteller anlegen</RouterLink>
                </Menu.Item>
                <Menu.Item asChild value="/systemdaten/herstellerliste">
                  <RouterLink to="/systemdaten/herstellerliste">Herstellerliste</RouterLink>
                </Menu.Item>
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>


        <Menu.Root autoSelect={false} navigate={(to) => navigate(to)}>
          <Menu.Trigger asChild>
            <Button
              variant="ghost"
              color={linkColor}
              _hover={{ color: linkHover, bg: "transparent" }}
            >
              Service Partner
              <LuChevronDown style={{ marginLeft: 8 }} />
            </Button>
          </Menu.Trigger>

          <Portal>
            <Menu.Positioner>
              <Menu.Content>
                <Menu.Item asChild value="/service-partner/neu">
                  <RouterLink to="/service-partner/neu">Neuen Service Partner anlegen</RouterLink>
                </Menu.Item>

                <Menu.Item asChild value="/service-partner/liste">
                  <RouterLink to="/service-partner/liste">Service Partner Liste</RouterLink>
                </Menu.Item>
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>


        <Menu.Root autoSelect={false} navigate={(to) => navigate(to)}>
          <Menu.Trigger asChild>
            <Button
              variant="ghost"
              color={linkColor}
              _hover={{ color: linkHover, bg: "transparent" }}
            >
              Wartung
              <LuChevronDown style={{ marginLeft: 8 }} />
            </Button>
          </Menu.Trigger>
          <Portal>
            <Menu.Positioner>
              <Menu.Content>
                <Menu.Item asChild value="/wartung/liste">
                  <RouterLink to="/wartung/liste">Wartungsliste</RouterLink>
                </Menu.Item>
                <Menu.Item asChild value="/wartung/protokoll">
                  <RouterLink to="/wartung/wartungsprotokoll">Wartungsprotokoll</RouterLink>
                </Menu.Item>
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>

        <Menu.Root autoSelect={false} navigate={(to) => navigate(to)}>
          <Menu.Trigger asChild>
            <Button
              variant="ghost"
              color={linkColor}
              _hover={{ color: linkHover, bg: "transparent" }}
            >
              Photovoltaikanlagen
              <LuChevronDown style={{ marginLeft: 8 }} />
            </Button>
          </Menu.Trigger>

          <Portal>
            <Menu.Positioner>
              <Menu.Content>
                {links.map(({ label, to }) => (
                  <Menu.Item asChild key={to} value={to}>
                    <RouterLink to={to}>{label}</RouterLink>
                  </Menu.Item>
                ))}
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>

        <Menu.Root>
          <Menu.Trigger asChild>
            <Button
              variant="ghost"
              color={linkColor}
              _hover={{ color: linkHover, bg: "transparent" }}
            >
              {user.email} <LuChevronDown style={{ marginLeft: 8 }} />
            </Button>
          </Menu.Trigger>
          <Portal>
            <Menu.Positioner>
              <Menu.Content>
                <Menu.Item onClick={() => navigate("/profil")} _hover={{ bg: "gray.100" }}>
                  Profil bearbeiten
                </Menu.Item>
                <Menu.Item onClick={() => navigate("/passwort")} _hover={{ bg: "gray.100" }}>
                  Passwort ändern
                </Menu.Item>
                <Menu.Item onClick={handleLogout} _hover={{ bg: "gray.100" }}>
                  Abmelden
                </Menu.Item>
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>

      </HStack>
    </Flex>
  );
}